/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { backgroundColor: '#efefef' } },
    { if: { focus: true }, tokens: { backgroundColor: '#efefef' } },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#c9c8c8', itemIconColor: '#000000' }
    }
  ],
  tokens: {
    backgroundColor: null,
    dividerColor: '#c9c8c8',
    dividerSize: 1,
    iconMarginTop: 0,
    interItemMargin: null,
    interItemMarginWithDivider: null,
    itemBulletColor: '#7c1366',
    itemBulletContainerAlign: 'center',
    itemBulletContainerWidth: 0,
    itemBulletHeight: 0,
    itemBulletWidth: 0,
    itemFontColor: '#000000',
    itemFontName: 'StagSans',
    itemFontSize: 16,
    itemFontWeight: '600',
    itemIconColor: '#000000',
    itemIconSize: 24,
    itemLineHeight: 1.6,
    itemUnderline: 'none',
    listGutter: 12,
    paddingBottom: 12,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 12
  }
}
export default theme
